import { render, staticRenderFns } from "./InventoryVautoControl.vue?vue&type=template&id=e3265a1c&scoped=true"
import script from "./InventoryVautoControl.vue?vue&type=script&lang=js"
export * from "./InventoryVautoControl.vue?vue&type=script&lang=js"
import "./InventoryVautoControl.vue?vue&type=style&index=0&id=e3265a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3265a1c",
  null
  
)

export default component.exports